import { render } from "./SectionNad2.vue?vue&type=template&id=06c762b1"
import script from "./SectionNad2.vue?vue&type=script&lang=js"
export * from "./SectionNad2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__